import React from 'react';
import { getZeroValue, formatAmountWithCurrency, getCurrencyFractionSeparator } from '@fxtr/i18n';

const formatQuoteEngineAmount = (amount) => {
  return amount / 100;
};

const addVat = (amount) => {
  const vatRate = 1.2;
  return amount * vatRate;
};

const withFractionSize = (amount, fractionSize, segment) => {
  const currencyFractionSeparator = getCurrencyFractionSeparator(segment);
  const [integer, fraction] = amount.split(currencyFractionSeparator);
  const formattedFraction = fraction ? (
    <span className="currency_fractions" style={{ fontSize: `${fractionSize}em` }}>
      {currencyFractionSeparator}
      {fraction}
    </span>
  ) : null;
  return (
    <>
      {integer}
      {formattedFraction}
    </>
  );
};

const Currency = ({
  children,
  vat = false,
  zeroValue = false,
  trailingZero = false,
  fractionSize,
  segment,
}) => {
  if (children === 0 && zeroValue) return getZeroValue(segment);
  if (!children || !isFinite(children)) return '';

  const formatAmount = formatQuoteEngineAmount(children);
  const finalAmount = vat ? addVat(formatAmount) : formatAmount;
  const hasFractionAmount = finalAmount % 1 > 0;
  const minimumFractionDigits = trailingZero || hasFractionAmount ? 2 : 0;
  const amountWithCurrency = formatAmountWithCurrency(finalAmount, segment, minimumFractionDigits);

  if (fractionSize) return withFractionSize(amountWithCurrency, fractionSize, segment);

  return amountWithCurrency;
};

export default Currency;
